import { IcerikMetaViewModel } from "../../models/viewModels/IcerikMetaViewModel";
import CsmGenericCheckboxListField, { ICsmGenericCheckboxListFieldProps } from "../../library/components/mui/common/CsmGenericCheckboxListField";

function VatanIcerikMetaCheckboxListEditor(props: ICsmGenericCheckboxListFieldProps<IcerikMetaViewModel, string>) {
    return <CsmGenericCheckboxListField {...props} />
}


export default VatanIcerikMetaCheckboxListEditor;